import { configureStore } from "@reduxjs/toolkit";
import RegistrationToggle from "./RegistrationModalToggle/toggleModal";
import MobileProdFilter from "./MobileProductFiltersModal/filterProductModal";
import productFilter from "./ProductFilter/ProductFilter";
import User from "../REDUX/Registration/Registration";
import DropDownNav from "./NavbarDropDownToggle/navBarDropToggle";
// import Registration from "../REDUX/Registration/Registration";
export const store = configureStore({
  reducer: {
    toggleReg: RegistrationToggle,
    toggleMobileProdFilter: MobileProdFilter,
    filterProds: productFilter,
    User: User,
    DropDownNav,
  },
});
